'use client'
import React, { useState, useEffect } from 'react'
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, useDisclosure } from "@nextui-org/react";
import LoginForm from './LoginForm';
import Link from 'next/link';
import { translateIt } from '@/data/translations';
import UserCreateForm from './UserCreateForm';


export default function LoginModal(props) {
  const {
    size = "full",
    heading = "Login",
    trigger = null,
    triggerOpen = false,
    countryId,
  } = props
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const [renderLogin, setRenderLogin] = useState(true)
  
  const handleOnLoginSuccess = () => {
    onOpenChange()
  }

  const handleCreateAccountClick = () => {
    setRenderLogin(!!!renderLogin)
  }

  useEffect(() => {
    if (triggerOpen) {
      onOpen()
    }
  }, [triggerOpen])

  return (
    <>
      <div onClick={onOpen}>
        {trigger && trigger}
      </div>

      <Modal isOpen={isOpen} onOpenChange={onOpenChange} size={size}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                {heading}
              </ModalHeader>
              <ModalBody>
                {renderLogin ?
                  <LoginForm onSuccess={handleOnLoginSuccess} countryId={countryId} />
                  : <UserCreateForm onSuccess={handleCreateAccountClick} countryId={countryId} />
                }

              </ModalBody>
              <ModalFooter>
                {renderLogin ? (
                  <>
                    {translateIt('en', 'login_dontHaveAnAccount')}
                    <span onClick={handleCreateAccountClick} className="ml-2 underline cursor-pointer">
                      {translateIt('en', 'login_createANewAccount')}
                    </span>
                  </>

                )
                : (
                  <>
                    {translateIt('en', 'login_alreadyHaveAnAccount')}
                    <span onClick={handleCreateAccountClick} className="ml-2 underline cursor-pointer">
                      {translateIt('en', 'login_clickHereToLogin')}
                    </span>
                  </>
                )
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  )
}
